import React, { FC } from 'react';

import { Button } from '@project/components';
import { useResponsive } from '@project/hooks';

export const BlankAccessLayout: FC = ({ children }) => {
  const date = new Date().getFullYear();
  const responsive = useResponsive();

  const _navigateToAdmin = () => {
    document.location.href = 'https://www.finessa.co.za';
  };
  const _aboutUs = (): void => {
    window.open('https://finessa.co.za/about-us/', '_blank');
  };
  const _services = (): void => {
    window.open('https://www.finessa.co.za/services.php', '_blank');
  };

  return (
    <>
      <div className="bg-cover h-screen absolute bottom-0 top-0 left-0 right-0 -z-10" />
      <div className="flex flex-1 flex-col h-screen">
        <nav className="px-4 justify-between bg-gray-200 h-20 bg-opacity-90">
          <ul className="h-full">
            <li className="py-3 h-full">
              <Button onClick={_navigateToAdmin} className="bg-transparent shadow-none">
                <img
                  src="assets/images/fines-sa-logo-primary.png"
                  alt="finesSA logo"
                  className="nav-logo"
                  width="120"
                />
              </Button>
            </li>
          </ul>
        </nav>
        {responsive.isMobile ? (
          <div className="py-4 inline-block overflow-y-auto">
            <div className="flex flex-1 items-center justify-center mb-3">{children}</div>
            <div className="border-t-2 border-text-grey flex flex-col px-6">
              <Button onClick={_aboutUs} type="text" className="text-black">
                About Us
              </Button>
              <Button onClick={_services} type="text" className="text-black">
                Services
              </Button>
              <p className="text-black">Copyright © {date} FinesSA</p>
            </div>
          </div>
        ) : (
          <>
            <div className="py-4 xs:inline-block xs:overflow-y-auto h-full">
              <div className="flex flex-1 items-center justify-center min-h-full">{children}</div>
            </div>
            <div className="h-20 bottom-0 border-t-2 border-text-grey justify-between flex px-6">
              <div className="flex">
                <Button onClick={_aboutUs} type="text" className="text-black">
                  About Us
                </Button>
                <Button onClick={_services} type="text" className="text-black">
                  Services
                </Button>
              </div>
              <p className="text-black pt-4">Copyright © {date} FinesSA</p>
            </div>
          </>
        )}
      </div>
    </>
  );
};
